import { getDateLocale } from './dateLocale'

const formatDateTime = (dateInput: Date | number) => {
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput)
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  }

  // Other languages get their own date order ("25.09.2026, 14:05").
  const locale = getDateLocale()
  if (locale) return new Intl.DateTimeFormat(locale, options).format(date)

  const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(date)

  const getPart = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value || ''

  return `${getPart('month')}/${getPart('day')}/${getPart('year')} ${getPart('hour')}:${getPart(
    'minute'
  )}`
}

export default formatDateTime
